export default "__VITE_ASSET__L35HnnTc__"